export default "__VITE_ASSET__BBZY02az__"